import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from '../ScrollToTop';
import { Suspense } from 'react';

export default function Layout() {
  const whatsappNumber = '56942470111';
  const whatsappMessage = encodeURIComponent('Hola, me interesa conocer más sobre sus servicios de hosting.');

  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-white flex flex-col">
        <Header />
        <main className="flex-1 pt-[64px] sm:pt-[80px]">
          <Suspense fallback={
            <div className="flex items-center justify-center min-h-[60vh]">
              <div className="flex flex-col items-center gap-4">
                <div className="w-10 h-10 border-4 border-gray-200 border-t-gray-800 rounded-full animate-spin"></div>
                <p className="text-gray-500 text-sm">Cargando...</p>
              </div>
            </div>
          }>
            <Outlet />
          </Suspense>
        </main>
        <Footer />

        {/* Floating WhatsApp Button */}
        <a
          href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
          target="_blank"
          rel="nofollow noreferrer"
          title="Contáctanos por WhatsApp"
          className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white pl-4 pr-5 py-3 rounded-full shadow-2xl shadow-green-500/40 hover:shadow-green-500/60 transition-all duration-300 hover:scale-105 group"
          style={{ bottom: '24px', right: '24px' }}
        >
          <div className="w-7 h-7 flex items-center justify-center">
            <i className="ri-whatsapp-line text-2xl"></i>
          </div>
          <span className="text-sm font-bold whitespace-nowrap max-w-0 overflow-hidden group-hover:max-w-xs transition-all duration-500 ease-in-out">
            ¡Escríbenos!
          </span>
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-green-300 rounded-full animate-ping"></span>
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full"></span>
        </a>
      </div>
    </>
  );
}